function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinglePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.86,361.67C491.07,304.19,493,227.6,473.5,166.2,456.73,113.34,419.41,73,376.31,49,326.3,21.15,266.7,12.86,213,30.44c-14.11,4.62-27.86,8.86-41.17,16.46-54.56,31.14-44,107.88-63.17,134.58-16.11,22.46-46.9,15.84-66.32,33.05C-10,261,20.3,380.69,76.48,423.65,141.89,473.67,393,504,462.86,361.67Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.86,361.67C491.07,304.19,493,227.6,473.5,166.2,456.73,113.34,419.41,73,376.31,49,326.3,21.15,266.7,12.86,213,30.44c-14.11,4.62-27.86,8.86-41.17,16.46-54.56,31.14-44,107.88-63.17,134.58-16.11,22.46-46.9,15.84-66.32,33.05C-10,261,20.3,380.69,76.48,423.65,141.89,473.67,393,504,462.86,361.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.59,136.68c2.93-.11,8.78-3.1,8.79-3.11s-3.14-3.26-3.37-3.44c-2.61-2.09-8.88-4.59-12-2.53a4.43,4.43,0,0,0-.78,6.55C23.89,136.2,27.09,136.77,29.59,136.68Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.09,109.09c.07,0-.82-4.45-.91-4.73-1-3.18-4.88-8.73-8.62-8.73a4.43,4.43,0,0,0-4.27,5c.27,2.63,2.62,4.88,4.76,6.18C83.55,108.35,90.08,109.09,90.09,109.09Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.41,79.11c-3.53,1.26-5.3,7.78-5.2,11.12,0,.29.67,4.79.73,4.76L93,95c-.28,1-.58,2.14-.88,3.35-.53,2.24-1.12,4.78-1.56,7.59a78.06,78.06,0,0,0-1,9.13,58.67,58.67,0,0,0,.32,10.27.5.5,0,0,1,0,.12c-.46-1-1.83-3.74-2-3.94-1.83-2.8-7-7.13-10.62-6.15a4.44,4.44,0,0,0-2.79,6c1,2.46,3.81,4,6.22,4.7,2.7.77,8.74-.12,9.22-.2A78.17,78.17,0,0,0,92.17,136c.54,2,1.16,3.91,1.8,5.87-.43-.85-.81-1.61-.88-1.71-1.83-2.8-7-7.13-10.62-6.15a4.44,4.44,0,0,0-2.79,6c.95,2.46,3.82,4,6.22,4.7s7.6,0,9-.16c.26.75.5,1.5.76,2.24,1.23,3.58,2.47,7.15,3.58,10.69.39,1.24.73,2.48,1.08,3.72-.38-.75-.71-1.38-.77-1.47-1.82-2.8-7-7.14-10.61-6.15a4.43,4.43,0,0,0-2.8,6c1,2.46,3.82,4,6.22,4.69s7.1.1,8.72-.12c.32,1.28.64,2.57.88,3.82.15.86.36,1.68.46,2.56s.24,1.71.35,2.56c.17,1.63.35,3.32.47,4.92.09,1.12.16,2.18.23,3.25-.37-1.25-1.16-3.67-1.25-3.86a17.2,17.2,0,0,0-5.72-6.54A4.75,4.75,0,0,0,96,170a4.43,4.43,0,0,0-6.51-1c-2.84,2.44-2.15,9.16-.85,12.24.08.19,1.13,2.07,1.81,3.24-.51-.63-1-1.25-1.52-1.89-1-1.27-2.11-2.52-3.26-3.86l-1.75-1.9c-.57-.65-1.26-1.26-1.89-1.9-1.49-1.45-3.08-2.85-4.71-4.23,1.12-.91,5-4.2,6.16-6.44s1.94-5.38.77-7.75a4.42,4.42,0,0,0-6.28-2c-3.18,2-3.51,8.73-2.69,12,0,.2.89,2.46,1.38,3.7-1-.82-2-1.64-3-2.44-3-2.29-6-4.52-9.06-6.76l-2.78-2.07c.4-.32,5.14-4.14,6.41-6.64,1.12-2.23,1.93-5.39.77-7.76a4.45,4.45,0,0,0-6.29-2c-3.17,2-3.51,8.73-2.69,12,.06.25,1.28,3.5,1.63,4.31-2-1.52-4-3.06-6-4.66a77.62,77.62,0,0,1-7.4-6.91c.19-.15,5.15-4.1,6.45-6.67,1.12-2.23,1.93-5.39.77-7.76a4.43,4.43,0,0,0-6.28-2c-3.18,2-3.51,8.72-2.7,12,.05.22,1,2.7,1.45,3.87l-.18.11a57.69,57.69,0,0,1-6.06-8.18c-1-1.58-1.86-3.15-2.67-4.7,1-.64,5.54-3.63,7-5.81s2.52-5.14,1.62-7.63a4.43,4.43,0,0,0-6-2.68c-3.38,1.62-4.45,8.29-4,11.6,0,.18.48,2,.83,3.29-.35-.7-.73-1.42-1-2.1-1.23-2.55-2.2-5-3-7.11-.47-1.22-.87-2.34-1.23-3.38.65-1.14,3.23-5.78,3.48-8.33s-.14-5.72-2.08-7.51a4.44,4.44,0,0,0-6.59.4c-2.24,3-.12,9.4,1.81,12.13.16.24,3.19,3.63,3.23,3.57l0-.07c.33,1,.69,2.1,1.11,3.28.79,2.16,1.71,4.6,2.88,7.19a79.59,79.59,0,0,0,4.19,8.18,57.63,57.63,0,0,0,5.93,8.38l.09.09c-.93-.58-3.6-2.1-3.81-2.2-3.07-1.32-9.78-2.08-12.25.73a4.44,4.44,0,0,0,1,6.53c2.15,1.53,5.39,1.23,7.77.49,2.69-.85,7.23-4.93,7.59-5.26A77.51,77.51,0,0,0,55,154.9c1.53,1.33,3.13,2.63,4.74,3.9-.83-.47-1.56-.89-1.67-.93-3.07-1.33-9.78-2.09-12.25.73a4.43,4.43,0,0,0,1,6.52c2.15,1.53,5.39,1.24,7.77.49s6.37-4.16,7.4-5.08L63.8,162c3,2.31,6,4.6,8.88,6.93,1,.82,2,1.67,3,2.52-.73-.42-1.35-.77-1.45-.81-3.07-1.33-9.78-2.09-12.25.73a4.43,4.43,0,0,0,1,6.52c2.15,1.53,5.39,1.24,7.78.49s6-3.83,7.2-4.91c1,.89,1.94,1.79,2.84,2.7.6.63,1.22,1.2,1.79,1.88L84.23,180c1,1.27,2.12,2.58,3.11,3.85.69.87,1.33,1.72,2,2.58-1-.83-3-2.42-3.17-2.53-2.84-1.78-9.35-3.55-12.22-1.14a4.44,4.44,0,0,0,0,6.6c1.89,1.84,5.14,2,7.61,1.66,2.72-.42,7.64-3.61,8.26-4,1.07,1.41,2.09,2.8,3,4.12,1.62,2.25,3.06,4.34,4.32,6.22l2.18-1.05c-1.37-1.95-2.94-4.13-4.71-6.48-1.08-1.44-2.27-3-3.5-4.51a49,49,0,0,0,3.57-4.39c2.63,1,8.11,1.09,8.81,1.09.11,1.77.21,3.49.27,5.12q.15,3.78.16,6.95l2.34-1.13c-.06-1.83-.16-3.82-.29-5.93-.1-1.8-.25-3.72-.43-5.69.7-.17,6.4-1.62,8.56-3.34,2-1.55,4-4.07,4-6.72a4.44,4.44,0,0,0-4.87-4.45c-3.71.47-6.84,6.46-7.46,9.74,0,.19-.2,2.34-.28,3.7-.07-.81-.13-1.59-.22-2.41-.16-1.64-.37-3.27-.59-5-.13-.85-.27-1.7-.41-2.56s-.35-1.74-.52-2.62c-.45-2-1-4.08-1.6-6.12,1.43-.15,6.51-.73,8.69-2s4.58-3.42,4.92-6a4.43,4.43,0,0,0-4.13-5.14c-3.75-.1-7.74,5.34-8.85,8.5-.07.19-.61,2.54-.89,3.84-.37-1.22-.73-2.45-1.15-3.68-1.19-3.54-2.52-7.09-3.82-10.64-.4-1.08-.79-2.17-1.18-3.26.51,0,6.57-.61,9-2,2.16-1.24,4.58-3.43,4.92-6.05a4.44,4.44,0,0,0-4.14-5.14c-3.74-.1-7.74,5.35-8.85,8.5-.08.24-.86,3.62-1,4.49-.86-2.39-1.69-4.78-2.42-7.18a78.35,78.35,0,0,1-2.35-9.84c.24,0,6.56-.58,9.06-2,2.16-1.24,4.58-3.42,4.92-6a4.43,4.43,0,0,0-4.14-5.13c-3.74-.1-7.74,5.34-8.85,8.49-.07.21-.66,2.79-.91,4H90.7A57.2,57.2,0,0,1,90.16,115c0-1.87.19-3.65.37-5.39,1.19,0,6.62,0,9-1s4.93-2.9,5.55-5.46a4.44,4.44,0,0,0-3.54-5.57c-3.71-.51-8.28,4.46-9.73,7.48-.08.16-.7,1.92-1.13,3.2.1-.78.18-1.59.28-2.34.39-2.8.91-5.35,1.4-7.6.28-1.27.57-2.42.84-3.5,1.18-.59,5.88-3,7.49-5s3-4.85,2.41-7.41A4.43,4.43,0,0,0,97.41,79.11Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.17,282.59c-2.92.21-9.07-2.12-9.08-2.12s2.77-3.59,3-3.79c2.36-2.36,8.32-5.54,11.65-3.83a4.43,4.43,0,0,1,1.5,6.42C488.78,281.49,485.66,282.41,483.17,282.59Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,261.78c-.07,0,.33-4.51.39-4.8.67-3.27,3.89-9.21,7.61-9.62a4.43,4.43,0,0,1,4.79,4.53c0,2.64-2.07,5.13-4.05,6.66C426.44,260.34,420,261.78,420,261.78Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.47,232.79c3.64.86,6.11,7.15,6.37,10.48,0,.29-.13,4.83-.2,4.81l-.07,0c.39,1,.81,2.06,1.24,3.23.77,2.17,1.63,4.63,2.38,7.38a77.37,77.37,0,0,1,2,9,57.22,57.22,0,0,1,.8,10.24.49.49,0,0,1,0,.12c.35-1,1.42-3.91,1.53-4.13,1.51-3,6.18-7.85,9.88-7.27a4.44,4.44,0,0,1,3.43,5.64c-.68,2.55-3.36,4.4-5.67,5.35-2.6,1.07-8.71.83-9.19.81a80.23,80.23,0,0,1-1.07,10.42c-.33,2-.73,4-1.15,6,.33-.89.63-1.69.68-1.79,1.51-3,6.19-7.86,9.89-7.27a4.43,4.43,0,0,1,3.42,5.63c-.67,2.56-3.35,4.4-5.66,5.35s-7.55.87-8.93.83c-.17.77-.33,1.54-.51,2.31-.83,3.69-1.67,7.37-2.39,11-.25,1.28-.45,2.55-.66,3.82.29-.79.55-1.45.59-1.55,1.52-3,6.19-7.86,9.89-7.27a4.43,4.43,0,0,1,3.43,5.63c-.68,2.56-3.36,4.41-5.67,5.35s-7.05.88-8.68.83c-.18,1.31-.35,2.62-.46,3.9-.05.87-.17,1.71-.17,2.59s0,1.73-.08,2.58c0,1.65,0,3.34.08,5,0,1.11.08,2.18.12,3.25.24-1.28.76-3.77.82-4a17.26,17.26,0,0,1,5-7.12,5.1,5.1,0,0,1,.39-.9,4.43,4.43,0,0,1,6.36-1.74c3.09,2.12,3.13,8.87,2.18,12.08-.06.19-.89,2.17-1.44,3.41.43-.68.84-1.35,1.3-2,.89-1.38,1.82-2.74,2.82-4.2l1.53-2.08c.5-.71,1.11-1.39,1.67-2.1,1.32-1.6,2.75-3.16,4.22-4.71-1.21-.78-5.46-3.62-6.83-5.73s-2.51-5.14-1.61-7.62a4.42,4.42,0,0,1,6-2.68c3.38,1.62,4.44,8.29,4,11.6,0,.21-.62,2.55-1,3.82.89-.92,1.77-1.84,2.7-2.74,2.69-2.61,5.49-5.16,8.27-7.72.85-.78,1.69-1.57,2.53-2.36-.43-.27-5.56-3.54-7.09-5.9-1.36-2.09-2.51-5.14-1.61-7.62a4.43,4.43,0,0,1,6-2.68c3.37,1.62,4.44,8.29,4,11.6,0,.25-.89,3.61-1.15,4.46,1.86-1.74,3.69-3.49,5.43-5.28a76.66,76.66,0,0,0,6.59-7.68c-.2-.13-5.56-3.52-7.13-5.93-1.36-2.1-2.51-5.14-1.61-7.63a4.43,4.43,0,0,1,6-2.68c3.38,1.62,4.44,8.29,4,11.61,0,.21-.68,2.78-1,4l.19.09a56.79,56.79,0,0,0,5.13-8.79c.82-1.68,1.5-3.34,2.14-5-1.07-.53-5.9-3-7.56-5s-3.06-4.83-2.44-7.4a4.44,4.44,0,0,1,5.7-3.33c3.53,1.25,5.32,7.76,5.24,11.1,0,.18-.26,2-.47,3.36.28-.73.57-1.49.82-2.2.94-2.67,1.64-5.18,2.24-7.4.33-1.27.6-2.42.84-3.5-.77-1.06-3.83-5.39-4.36-7.89s-.49-5.7,1.24-7.7a4.43,4.43,0,0,1,6.59-.32c2.56,2.73,1.15,9.33-.46,12.26-.14.25-2.79,3.95-2.83,3.9l0-.07c-.22,1.05-.46,2.16-.75,3.38-.55,2.24-1.19,4.76-2.08,7.47a79.72,79.72,0,0,1-3.27,8.58,57.32,57.32,0,0,1-5,9,.86.86,0,0,1-.07.1c.86-.67,3.34-2.48,3.55-2.6,2.9-1.66,9.49-3.14,12.25-.61a4.43,4.43,0,0,1-.25,6.59c-2,1.75-5.23,1.82-7.68,1.33-2.76-.54-7.72-4.1-8.12-4.39a76.66,76.66,0,0,1-6.63,8.09c-1.39,1.5-2.83,3-4.29,4.4.77-.56,1.46-1.05,1.56-1.11,2.91-1.66,9.49-3.15,12.25-.62a4.42,4.42,0,0,1-.25,6.59c-2,1.76-5.22,1.83-7.67,1.34s-6.78-3.44-7.91-4.24c-.56.55-1.12,1.11-1.69,1.65-2.73,2.62-5.47,5.23-8.07,7.87-.92.92-1.79,1.87-2.66,2.82.68-.5,1.26-.91,1.35-1,2.91-1.65,9.49-3.14,12.25-.61a4.42,4.42,0,0,1-.25,6.59c-2,1.76-5.22,1.82-7.67,1.34s-6.36-3.16-7.7-4.1c-.87,1-1.74,2-2.53,3-.53.7-1.08,1.33-1.57,2.06l-1.49,2.12c-.9,1.38-1.83,2.8-2.67,4.16-.59,1-1.13,1.87-1.69,2.78.91-.93,2.71-2.72,2.88-2.86,2.62-2.07,8.91-4.54,12-2.46a4.43,4.43,0,0,1,.75,6.55c-1.68,2-4.89,2.59-7.38,2.49-2.75-.12-8-2.76-8.65-3.09-.91,1.52-1.78,3-2.57,4.43-1.37,2.41-2.57,4.65-3.62,6.65l-2.27-.8c1.14-2.08,2.46-4.42,4-7,.91-1.55,1.92-3.19,3-4.86a48.71,48.71,0,0,1-4-4c-2.5,1.32-7.94,2-8.64,2,.08,1.77.18,3.5.3,5.12.17,2.52.38,4.83.59,6.92l-2.44-.86q-.21-2.75-.37-5.93c-.09-1.8-.15-3.72-.19-5.7-.72-.09-6.54-.91-8.87-2.38-2.11-1.33-4.43-3.61-4.66-6.25a4.43,4.43,0,0,1,4.35-5c3.74.06,7.51,5.67,8.48,8.87.06.19.45,2.3.68,3.64,0-.8,0-1.59,0-2.42,0-1.64,0-3.29,0-5.05,0-.85.08-1.72.12-2.59s.16-1.77.24-2.66c.22-2.07.54-4.16.92-6.26-1.44,0-6.56,0-8.86-1s-4.93-2.91-5.55-5.47a4.43,4.43,0,0,1,3.55-5.56c3.71-.51,8.28,4.46,9.72,7.47.09.19.89,2.47,1.3,3.73.24-1.26.47-2.51.74-3.78.81-3.65,1.74-7.33,2.64-11,.28-1.13.55-2.25.82-3.37-.52,0-6.6.11-9.17-1-2.29-1-4.93-2.9-5.55-5.47a4.42,4.42,0,0,1,3.54-5.55c3.71-.51,8.28,4.46,9.73,7.47.11.23,1.25,3.51,1.5,4.36.59-2.47,1.15-4.94,1.61-7.4a78.75,78.75,0,0,0,1.27-10c-.24,0-6.59.13-9.23-1-2.29-1-4.93-2.9-5.55-5.47a4.43,4.43,0,0,1,3.55-5.56c3.71-.51,8.28,4.46,9.72,7.47.1.2,1,2.7,1.36,3.9l.21,0a56.9,56.9,0,0,0-.57-10.16c-.25-1.86-.59-3.61-1-5.32-1.18.15-6.57.75-9.06,0s-5.22-2.34-6.12-4.82a4.44,4.44,0,0,1,2.91-5.92c3.63-.91,8.72,3.53,10.49,6.37.1.15.9,1.83,1.47,3.06-.18-.77-.35-1.57-.53-2.3-.69-2.74-1.49-5.21-2.22-7.4-.42-1.24-.83-2.35-1.22-3.38-1.24-.46-6.18-2.38-8-4.18s-3.55-4.48-3.2-7.11A4.43,4.43,0,0,1,409.47,232.79Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.86,418.42c-1.6.8-5.61.91-5.61.91s.72-2.67.79-2.83c.79-1.88,3.42-5.06,5.69-4.87a2.7,2.7,0,0,1,2.35,3.27C461.78,416.49,460.23,417.74,458.86,418.42Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,421.36s-.86-2.63-.9-2.8c-.38-2,.06-6.11,2.06-7.21a2.7,2.7,0,0,1,3.76,1.45c.63,1.48,0,3.38-.74,4.7C421.65,419.05,418.36,421.36,418.36,421.36Z",
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.24,464.59c.49,1.11,1,2.18,1.44,3.17s.78,1.64,1.15,2.39h1.59c-.48-.92-1-1.91-1.52-3-.44-.89-.9-1.84-1.36-2.82a19.6,19.6,0,0,0,4.4-3.17,27.42,27.42,0,0,0,3.2,1.31c-.2,1.19-.39,2.35-.55,3.44-.22,1.53-.4,2.94-.55,4.22h1.45c.12-1.23.26-2.58.44-4,.12-1,.27-2,.43-3.1.44,0,4,.31,5.6-.27s3.11-1.58,3.59-3.12a2.7,2.7,0,0,0-1.95-3.52c-2.24-.45-5.22,2.4-6.21,4.18-.07.12-.67,1.55-1,2.29.09-.65.19-1.29.3-2,.16-1,.36-2,.54-3,.11-.51.23-1,.35-1.54s.27-1,.4-1.53c.22-.75.48-1.52.74-2.28a17.09,17.09,0,0,0,5.3.52c1.49-.29,3.32-1.09,4-2.54a2.71,2.71,0,0,0-1.39-3.78c-2.15-.78-5.52,1.59-6.78,3.2,0,.05-.27.42-.54.86.28-.74.55-1.48.85-2.22.86-2.09,1.79-4.2,2.73-6.31l.57-1.33c.82.19,3.93.86,5.45.56s3.32-1.09,4-2.55a2.71,2.71,0,0,0-1.39-3.78c-2.15-.78-5.52,1.59-6.78,3.2,0,.06-.32.5-.62,1,.49-1.15,1-2.31,1.4-3.48a47.43,47.43,0,0,0,1.86-6.11c.29.07,3.92.92,5.61.59,1.5-.3,3.32-1.09,4-2.54a2.71,2.71,0,0,0-1.4-3.78c-2.14-.79-5.52,1.59-6.77,3.2-.09.11-1.07,1.71-1.4,2.29a.19.19,0,0,1,0-.07,36.44,36.44,0,0,0,.72-6.23,48.33,48.33,0,0,0-.15-5.61c-.13-1.73-.35-3.31-.56-4.7-.12-.75-.25-1.44-.37-2.08l0,0s.67-2.68.69-2.86c.23-2-.51-6.08-2.59-7a2.7,2.7,0,0,0-3.64,1.72c-.52,1.53.22,3.37,1.08,4.63s3.62,3,4.3,3.45c.12.66.23,1.38.34,2.17.18,1.39.37,3,.46,4.7,0,.46,0,.95.05,1.43-.2-.8-.48-1.9-.52-2-.73-1.91-3.26-5.17-5.54-5.05a2.7,2.7,0,0,0-2.44,3.2c.24,1.6,1.75,2.89,3.1,3.62s4.71,1,5.43,1.07c0,1.07,0,2.16-.05,3.3a36,36,0,0,1-.85,6.16h-.13c-.09-.76-.32-2.36-.36-2.49-.51-2-2.67-5.5-4.95-5.63a2.72,2.72,0,0,0-2.78,2.92c.07,1.61,1.43,3.06,2.69,3.93,1.45,1,5.26,1.66,5.41,1.69a48.54,48.54,0,0,1-1.94,5.87c-.56,1.42-1.19,2.83-1.84,4.24,0-.53-.35-2.63-.38-2.78-.52-2-2.67-5.5-5-5.63a2.71,2.71,0,0,0-2.77,2.92c.07,1.61,1.43,3.06,2.68,3.93,1.41,1,5.07,1.63,5.38,1.68-.3.64-.59,1.28-.89,1.93-1,2.09-2,4.18-2.87,6.28-.32.72-.6,1.45-.89,2.18-.1-.81-.31-2.27-.34-2.39-.51-2-2.67-5.5-4.95-5.63a2.72,2.72,0,0,0-2.78,2.92c.07,1.61,1.43,3.06,2.69,3.93s4.32,1.49,5.19,1.65c-.48,1.21-.92,2.42-1.29,3.64-.15.53-.34,1.06-.46,1.57s-.25,1-.38,1.53c-.22,1.06-.43,2-.61,3-.1.5-.17,1-.26,1.46,0-.83,0-2.15,0-2.27-.21-2-1.81-5.83-4-6.31a2.71,2.71,0,0,0-3.19,2.46,4,4,0,0,0,0,.6,10.53,10.53,0,0,0-1.15,5.18c0,.13.3,1.66.47,2.43-.28-.59-.55-1.18-.83-1.8-.41-.9-.8-1.85-1.19-2.78l-.57-1.48c-.2-.49-.33-1-.5-1.5-.23-.74-.44-1.52-.65-2.3a17.26,17.26,0,0,0,4.71-2.49c1.09-1.07,2.17-2.74,2-4.34a2.71,2.71,0,0,0-3.25-2.39c-2.22.53-3.73,4.37-3.89,6.41,0,.07,0,.5,0,1-.18-.76-.36-1.53-.52-2.31-.44-2.22-.82-4.49-1.21-6.77-.08-.48-.17-.95-.25-1.43.79-.29,3.75-1.45,4.85-2.54s2.17-2.74,1.95-4.34a2.7,2.7,0,0,0-3.24-2.38c-2.23.53-3.73,4.37-3.89,6.4,0,.08,0,.59,0,1.17-.23-1.23-.48-2.46-.76-3.67a47.37,47.37,0,0,0-1.82-6.13c.28-.1,3.78-1.39,5-2.6s2.16-2.74,1.95-4.34A2.7,2.7,0,0,0,427,421c-2.22.53-3.72,4.37-3.88,6.4,0,.15.05,2,.1,2.69l0-.07a35.33,35.33,0,0,0-2.83-5.6,49.49,49.49,0,0,0-3.22-4.59c-1.07-1.38-2.12-2.57-3.07-3.61-.51-.57-1-1.07-1.45-1.54h.05s-.92-2.61-1-2.76c-.93-1.82-3.78-4.8-6-4.44a2.7,2.7,0,0,0-2.09,3.44c.41,1.56,2.05,2.69,3.46,3.27s4.68.52,5.49.5c.46.49,1,1,1.47,1.62.92,1.07,1.95,2.28,3,3.67.27.37.55.78.83,1.17-.6-.56-1.45-1.32-1.54-1.39-1.66-1.19-5.56-2.51-7.4-1.15a2.7,2.7,0,0,0-.27,4c1.08,1.19,3.06,1.44,4.58,1.3s4.49-1.74,5.12-2.1c.61.88,1.21,1.79,1.78,2.78a34.64,34.64,0,0,1,2.68,5.61l-.11.06c-.5-.58-1.57-1.79-1.67-1.88-1.52-1.37-5.25-3.11-7.23-2a2.7,2.7,0,0,0-.71,4c1,1.31,2.88,1.77,4.41,1.8,1.75,0,5.31-1.52,5.44-1.58a46.68,46.68,0,0,1,1.62,6c.32,1.49.57,3,.81,4.56-.34-.43-1.74-2-1.86-2.12-1.52-1.36-5.25-3.11-7.23-2a2.71,2.71,0,0,0-.71,4c.95,1.3,2.88,1.77,4.41,1.79,1.71,0,5.13-1.43,5.41-1.56l.33,2.09c.34,2.29.67,4.58,1.06,6.83.14.78.31,1.54.47,2.31-.53-.62-1.51-1.72-1.6-1.81-1.52-1.36-5.26-3.11-7.24-2a2.71,2.71,0,0,0-.71,4c.95,1.3,2.89,1.76,4.41,1.79s4.43-1.14,5.24-1.48c.27,1.27.58,2.52.93,3.74.17.53.3,1.07.49,1.57s.36,1,.53,1.48c.4,1,.76,1.94,1.16,2.87.19.46.39.9.58,1.36-.44-.71-1.15-1.81-1.23-1.91-1.29-1.57-4.72-3.87-6.85-3a2.7,2.7,0,0,0-1.3,3.81c.74,1.44,2.58,2.19,4.08,2.45C427.34,465.59,430.82,464.7,431.24,464.59Z",
    style: {
      fill: "#C33030"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--web-page--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.15,
    y: 38.95,
    width: 324.33,
    height: 384.12,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,43.39a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,396.05,43.39Z",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.84,43.39a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,405.84,43.39Z",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.63,43.39A2.61,2.61,0,1,1,413,40.78,2.61,2.61,0,0,1,415.63,43.39Z",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.15,
    y: 47.43,
    width: 324.33,
    height: 384.12,
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7,69.5v-7A6.71,6.71,0,0,0,187,55.79H118.38a6.71,6.71,0,0,0-6.71,6.71v7h-8.52V431.55H427.48V69.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,69.5v-7a6.71,6.71,0,0,0-6.71-6.71H205.67A6.72,6.72,0,0,0,199,62.5v7H103.15V431.55H427.48V69.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,69.5v-7A6.71,6.71,0,0,0,368,55.79H299.34a6.72,6.72,0,0,0-6.72,6.71v7H103.15V431.55H427.48V69.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.19,
    y: 259.47,
    width: 98.39,
    height: 67.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.77,
    y: 136.09,
    width: 309.44,
    height: 99.88,
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.77,
    y: 244.78,
    width: 79.32,
    height: 168.43,
    style: {
      fill: "#C33030"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.71 235.97 313.4 235.97 313.4 123.61 414.71 155.97 414.71 235.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.71 235.97 313.4 235.97 313.4 215.68 414.71 221.53 414.71 235.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.59 146.84 320.01 142.63 320.01 135.6 335.59 140.13 335.59 146.84",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.27 152.38 317.02 146.94 317.02 139.85 338.27 145.72 338.27 152.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.55 153.05 345.11 149.42 345.11 142.9 358.55 146.81 358.55 153.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.87 158.16 342.54 153.47 342.54 146.9 360.87 151.96 360.87 158.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.52 158.45 366.81 155.29 366.81 149.21 378.52 152.61 378.52 158.45",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.55 163.19 364.57 159.1 364.57 152.98 380.55 157.39 380.55 163.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.04 163.19 385.75 160.41 385.75 154.72 396.04 157.71 396.04 163.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.83 167.61 383.79 164.02 383.79 158.29 397.83 162.16 397.83 167.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.55 167.39 402.42 164.92 402.42 159.57 411.55 162.22 411.55 167.39",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.14 171.52 400.69 168.34 400.69 162.95 413.14 166.39 413.14 171.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.59 166.24 320.01 162.94 320.01 155.91 335.59 159.53 335.59 166.24",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.27 171.62 317.02 167.43 317.02 160.34 338.27 164.96 338.27 171.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.55 171.1 345.11 168.25 345.11 161.73 358.55 164.85 358.55 171.1",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.87 176.06 342.54 172.46 342.54 165.88 360.87 169.87 360.87 176.06",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.52 175.32 366.81 172.84 366.81 166.77 378.52 169.48 378.52 175.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.55 179.94 364.57 176.79 364.57 170.67 380.55 174.14 380.55 179.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.04 179.03 385.75 176.85 385.75 171.16 396.04 173.55 396.04 179.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.83 183.34 383.79 180.58 383.79 174.84 397.83 177.9 397.83 183.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.55 182.31 402.42 180.38 402.42 175.03 411.55 177.14 411.55 182.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.14 186.35 400.69 183.9 400.69 178.52 413.14 181.22 413.14 186.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.59 185.63 320.01 183.25 320.01 176.22 335.59 178.92 335.59 185.63",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.27 190.85 317.02 187.92 317.02 180.83 338.27 184.19 338.27 190.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.55 189.14 345.11 187.09 345.11 180.57 358.55 182.89 358.55 189.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.87 193.97 342.54 191.44 342.54 184.87 360.87 187.77 360.87 193.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.52 192.19 366.81 190.4 366.81 184.32 378.52 186.35 378.52 192.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.55 196.69 364.57 194.48 364.57 188.36 380.55 190.89 380.55 196.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.04 194.87 385.75 193.29 385.75 187.6 396.04 189.38 396.04 194.87",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.83 199.07 383.79 197.13 383.79 191.4 397.83 193.63 397.83 199.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.55 197.24 402.42 195.84 402.42 190.49 411.55 192.07 411.55 197.24",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.14 201.19 400.69 199.47 400.69 194.08 413.14 196.05 413.14 201.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.59 205.03 320.01 203.56 320.01 196.53 335.59 198.31 335.59 205.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.27 210.09 317.02 208.41 317.02 201.31 338.27 203.43 338.27 210.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.55 207.18 345.11 205.92 345.11 199.4 358.55 200.94 358.55 207.18",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.87 211.88 342.54 210.43 342.54 203.85 360.87 205.68 360.87 211.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.52 209.06 366.81 207.96 366.81 201.88 378.52 203.22 378.52 209.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.55 213.44 364.57 212.17 364.57 206.05 380.55 207.64 380.55 213.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.04 210.7 385.75 209.74 385.75 204.04 396.04 205.22 396.04 210.7",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.83 214.8 383.79 213.69 383.79 207.96 397.83 209.36 397.83 214.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.55 212.16 402.42 211.3 402.42 205.95 411.55 206.99 411.55 212.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.14 216.02 400.69 215.03 400.69 209.64 413.14 210.88 413.14 216.02",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.26,
    y: 130.8,
    width: 25.82,
    height: 105.13,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.39,
    y: 124.14,
    width: 25.82,
    height: 111.79,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.26 235.82 161.16 235.97 161.16 151.7 265.26 130.8 265.26 235.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.26 235.82 161.16 235.97 161.16 220.75 265.26 216.86 265.26 235.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.53 162.18 165.15 163.94 165.15 158.52 175.53 156.62 175.53 162.18",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.47 165.88 163.31 168.16 163.31 162.76 177.47 160.3 177.47 165.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.92 159.05 182.66 160.97 182.66 155.32 193.92 153.26 193.92 159.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.03 162.89 180.67 165.37 180.67 159.74 196.03 157.07 196.03 162.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.92 155.65 201.66 157.73 201.66 151.84 213.92 149.6 213.92 155.65",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.22 159.64 199.5 162.33 199.5 156.47 216.22 153.57 216.22 159.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.76 151.93 222.36 154.21 222.36 148.06 235.76 145.6 235.76 151.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.28 156.09 220 159.03 220 152.91 238.28 149.73 238.28 156.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.7 147.85 245 150.35 245 143.91 259.7 141.23 259.7 147.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.47 152.19 242.42 155.42 242.42 149.01 262.47 145.53 262.47 152.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.53 178.23 165.15 179.62 165.15 174.19 175.53 172.68 175.53 178.23",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.47 182 163.31 183.76 163.31 178.36 177.47 176.42 177.47 182",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.92 175.78 182.66 177.28 182.66 171.63 193.92 169.99 193.92 175.78",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.03 179.7 180.67 181.61 180.67 175.98 196.03 173.88 196.03 179.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.92 173.11 201.66 174.74 201.66 168.85 213.92 167.06 213.92 173.11",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.22 177.19 199.5 179.27 199.5 173.4 216.22 171.11 216.22 177.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.76 170.19 222.36 171.98 222.36 165.83 235.76 163.87 235.76 170.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.28 174.45 220 176.72 220 170.59 238.28 168.09 238.28 174.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.7 167 245 168.96 245 162.52 259.7 160.37 259.7 167",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.47 171.44 242.42 173.93 242.42 167.52 262.47 164.78 262.47 171.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.53 194.28 165.15 195.29 165.15 189.86 175.53 188.73 175.53 194.28",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.47 198.13 163.31 199.37 163.31 193.97 177.47 192.55 177.47 198.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.92 192.5 182.66 193.59 182.66 187.95 193.92 186.72 193.92 192.5",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.03 196.5 180.67 197.85 180.67 192.23 196.03 190.69 196.03 196.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.92 190.57 201.66 191.76 201.66 185.87 213.92 184.53 213.92 190.57",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.22 194.73 199.5 196.2 199.5 190.34 216.22 188.66 216.22 194.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.76 188.46 222.36 189.75 222.36 183.6 235.76 182.13 235.76 188.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.28 192.8 220 194.4 220 188.28 238.28 186.45 238.28 192.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.7 186.14 245 187.56 245 181.12 259.7 179.51 259.7 186.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.47 190.69 242.42 192.44 242.42 186.03 262.47 184.02 262.47 190.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.53 210.34 165.15 210.96 165.15 205.54 175.53 204.78 175.53 210.34",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.47 214.25 163.31 214.97 163.31 209.57 177.47 208.67 177.47 214.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.92 209.23 182.66 209.91 182.66 204.26 193.92 203.44 193.92 209.23",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.03 213.31 180.67 214.09 180.67 208.47 196.03 207.49 196.03 213.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.92 208.03 201.66 208.77 201.66 202.88 213.92 201.99 213.92 208.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.22 212.28 199.5 213.13 199.5 207.27 216.22 206.21 216.22 212.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.76 206.72 222.36 207.53 222.36 201.37 235.76 200.4 235.76 206.72",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.28 211.16 220 212.09 220 205.97 238.28 204.81 238.28 211.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.7 205.28 245 206.17 245 199.73 259.7 198.66 259.7 205.28",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.47 209.93 242.42 210.95 242.42 204.54 262.47 203.27 262.47 209.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.81 235.97 276.11 235.97 303.87 114.96 310.81 122.34 310.81 235.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.87 235.97 269.18 235.97 269.18 122.41 303.87 114.96 303.87 235.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,254.45a8.75,8.75,0,0,0-8.75,8.75c0,4.84,8.75,14.72,8.75,14.72s8.76-9.88,8.76-14.72A8.76,8.76,0,0,0,319.3,254.45Zm0,11.92a3,3,0,1,1,3-3A3,3,0,0,1,319.3,266.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.17,265.19c-.6-.41-9.46-5.82-10-6.22l.19-.21,2-2.06a.5.5,0,0,1,.59-.16l3.1,1,4.68,1.54,3.48,1.17.51.14c.12-.12.24-.22.34-.33l4.49-4.67a2.66,2.66,0,0,1,1.31-.8,2.33,2.33,0,0,1,2.47,1,2.25,2.25,0,0,1-.14,2.66,15.2,15.2,0,0,1-1.12,1.15l-3.89,3.73-.11.11a.45.45,0,0,0-.15.59c.35,1,.67,2,1,3,.4,1.19.8,2.39,1.19,3.58q.77,2.29,1.52,4.57a.42.42,0,0,1,0,.1c.12.44.24.43-.2.86-.61.59-1.2,1.19-1.8,1.79-.11.11-.23.2-.32.29s-.2-.12-.25-.21q-1.27-2-2.53-4.1c-1-1.64-2-3.29-3.05-4.94-.09-.14-.17-.3-.27-.44a1.55,1.55,0,0,0-.22-.24c-.31.28-.6.55-.88.83q-1.95,1.86-3.89,3.73c-.51.48-.51.49-.39,1.21l.3,1.84c0,.22.07.44.1.67a12.27,12.27,0,0,1-1.12,1.16,10.66,10.66,0,0,1-1.13,1.09,10.1,10.1,0,0,1-.6-1.57c-.19-.51-.37-1-.55-1.56s-.37-1-.56-1.58c-1.57-.58-3.15-1.11-4.76-1.7a.87.87,0,0,1,.13-.19c.62-.62,1.25-1.24,1.86-1.87a.6.6,0,0,1,.61-.19c.54.1,1.09.18,1.63.27l1,.16a.46.46,0,0,0,.51-.15,2.13,2.13,0,0,1,.26-.26l4.3-4.49C354,265.45,354,265.34,354.17,265.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.13,256.68h-12a1.06,1.06,0,0,0-1,.8l-1.5,6.29h17l-1.5-6.29A1.06,1.06,0,0,0,396.13,256.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.32 257.86 384.97 257.86 383.68 263.25 396.61 263.25 395.32 257.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5,270.58h4a0,0,0,0,1,0,0v5.1a.58.58,0,0,1-.58.58h-2.82a.58.58,0,0,1-.58-.58v-5.1A0,0,0,0,1,380.5,270.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.2,270.58h4a0,0,0,0,1,0,0v5.1a.58.58,0,0,1-.58.58h-2.82a.58.58,0,0,1-.58-.58v-5.1A0,0,0,0,1,396.2,270.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.35,
    y: 257.47,
    width: 3.82,
    height: 1.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.08,
    y: 262.63,
    width: 22.69,
    height: 9.64,
    rx: 1.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.46,266.89a2.56,2.56,0,1,1-2.56-2.55A2.56,2.56,0,0,1,386.46,266.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.69,266.89a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,399.69,266.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.63,
    y: 265.34,
    width: 5.67,
    height: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.63,
    y: 267.06,
    width: 5.67,
    height: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.05,
    y: 274.79,
    width: 68.69,
    height: 25.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,296.22h60.73a4,4,0,0,1,4,4v17.94a0,0,0,0,1,0,0H216a0,0,0,0,1,0,0V300.2A4,4,0,0,1,220,296.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.33 295.57 235.37 294.89 222.36 294.89 218.71 295.57 219.63 292.84 219.63 285.31 218.71 282.57 222.48 283.37 235.94 283.37 238.33 282.57 237.42 285.76 237.42 292.15 238.33 295.57",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.32 295.57 256.36 294.89 243.35 294.89 239.7 295.57 240.62 292.84 240.62 285.31 239.7 282.57 243.47 283.37 256.93 283.37 259.32 282.57 258.41 285.76 258.41 292.15 259.32 295.57",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.31 295.57 277.35 294.89 264.34 294.89 260.69 295.57 261.6 292.84 261.6 285.31 260.69 282.57 264.46 283.37 277.92 283.37 280.31 282.57 279.4 285.76 279.4 292.15 280.31 295.57",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.91,
    y1: 318.15,
    x2: 299.45,
    y2: 318.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.02,
    y: 290.1,
    width: 1.53,
    height: 6.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.69,
    y: 278.11,
    width: 10.2,
    height: 12.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.18,
    y: 297.24,
    width: 11.22,
    height: 20.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.18,
    y: 297.24,
    width: 11.22,
    height: 3.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 302.34,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 309.48,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.62,
    y: 290.1,
    width: 1.53,
    height: 6.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.28,
    y: 278.11,
    width: 10.2,
    height: 12.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.77,
    y: 297.24,
    width: 11.22,
    height: 20.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.77,
    y: 297.24,
    width: 11.22,
    height: 3.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.3,
    y: 302.34,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.3,
    y: 309.48,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.18,
    y: 383.43,
    width: 11.22,
    height: 20.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.18,
    y: 383.43,
    width: 11.22,
    height: 3.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 388.53,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 395.67,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.77,
    y: 383.43,
    width: 11.22,
    height: 20.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.77,
    y: 383.43,
    width: 11.22,
    height: 3.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.3,
    y: 388.53,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.3,
    y: 395.67,
    width: 7.65,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.19,
    y: 345.67,
    width: 98.39,
    height: 67.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.05,
    y: 360.98,
    width: 68.69,
    height: 25.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,382.42h60.73a4,4,0,0,1,4,4v17.94a0,0,0,0,1,0,0H216a0,0,0,0,1,0,0V386.4A4,4,0,0,1,220,382.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.91,
    y1: 404.34,
    x2: 299.45,
    y2: 404.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2,91.24v6.82h-1.69V82.9h1.69v6.82h3.72V82.9h1.69V98.06h-1.69V91.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.22,86.56c0-2.32,1.14-3.82,3.46-3.82s3.49,1.5,3.49,3.82V94.4c0,2.3-1.15,3.81-3.49,3.81s-3.46-1.51-3.46-3.81Zm1.66,7.93c0,1.38.59,2.18,1.8,2.18s1.8-.8,1.8-2.18v-8c0-1.37-.56-2.19-1.8-2.19s-1.8.82-1.8,2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,98.06V84.43h-2.79V82.9h7.28v1.53h-2.8V98.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,89.61v1.52h-3.71v5.39h4.55v1.54h-6.24V82.9h6.24v1.53h-4.55v5.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43,98.06V82.9h1.69V96.52h4.33v1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,82.9c2.36,0,3.29,1.12,3.29,3.35V87c0,1.6-.45,2.6-1.77,3,1.47.41,2,1.58,2,3.25v1.28c0,2.27-1.1,3.55-3.46,3.55h-3.49V82.9Zm-.41,6.43c1.34,0,2-.43,2-2v-.88c0-1.35-.45-2-1.66-2h-1.67v4.9Zm.5,7.19c1.23,0,1.79-.65,1.79-2.06V93.12c0-1.69-.67-2.25-2.12-2.25h-1.47v5.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.45,86.56c0-2.32,1.15-3.82,3.46-3.82s3.49,1.5,3.49,3.82V94.4c0,2.3-1.15,3.81-3.49,3.81s-3.46-1.51-3.46-3.81Zm1.67,7.93c0,1.38.58,2.18,1.79,2.18s1.8-.8,1.8-2.18v-8c0-1.37-.56-2.19-1.8-2.19s-1.79.82-1.79,2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,86.56c0-2.32,1.15-3.82,3.47-3.82s3.49,1.5,3.49,3.82V94.4c0,2.3-1.15,3.81-3.49,3.81s-3.47-1.51-3.47-3.81Zm1.67,7.93c0,1.38.59,2.18,1.8,2.18s1.8-.8,1.8-2.18v-8c0-1.37-.57-2.19-1.8-2.19s-1.8.82-1.8,2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,91.47l-.89,1.5v5.09h-1.69V82.9h1.69v7.32l4-7.32h1.71L190,89.81l4,8.25h-1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,82.9V98.06h-1.69V82.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.21,98.06h-1.52V82.9h2.14l3.51,11v-11h1.5V98.06h-1.76L200.21,85.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,86.56v1.3h-1.6V86.47c0-1.37-.54-2.19-1.78-2.19s-1.77.82-1.77,2.19v8c0,1.36.56,2.18,1.77,2.18s1.78-.82,1.78-2.18v-3H211.1V89.94h3.16V94.4c0,2.3-1.08,3.81-3.42,3.81s-3.4-1.51-3.4-3.81V86.56c0-2.3,1.08-3.82,3.4-3.82S214.26,84.26,214.26,86.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.51,
    y: 108.33,
    width: 57.8,
    height: 9.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.7,
    y: 108.33,
    width: 57.8,
    height: 9.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.19,
    y1: 62.87,
    x2: 361.69,
    y2: 62.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.58,
    y: 320.03,
    width: 16.23,
    height: 9.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.1,
    y: 320.03,
    width: 16.23,
    height: 9.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 292.76,
    x2: 407.11,
    y2: 292.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 299.9,
    x2: 407.11,
    y2: 299.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 307.04,
    x2: 407.11,
    y2: 307.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 314.19,
    x2: 407.11,
    y2: 314.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,340.31a8.75,8.75,0,0,0-8.75,8.75c0,4.84,8.75,14.72,8.75,14.72s8.76-9.88,8.76-14.72A8.76,8.76,0,0,0,319.3,340.31Zm0,11.92a3,3,0,1,1,3-3A3,3,0,0,1,319.3,352.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.17,351.05c-.6-.41-9.46-5.82-10-6.22a2.2,2.2,0,0,1,.19-.21l2-2.06a.5.5,0,0,1,.59-.16l3.1,1,4.68,1.54,3.48,1.17.51.14c.12-.12.24-.22.34-.33,1.5-1.56,3-3.12,4.49-4.67a2.66,2.66,0,0,1,1.31-.8,2.33,2.33,0,0,1,2.47,1,2.25,2.25,0,0,1-.14,2.66,15.2,15.2,0,0,1-1.12,1.15l-3.89,3.73-.11.11a.45.45,0,0,0-.15.59c.35,1,.67,2,1,3,.4,1.19.8,2.39,1.19,3.58q.77,2.3,1.52,4.57a.42.42,0,0,1,0,.1c.12.44.24.43-.2.86-.61.59-1.2,1.19-1.8,1.79-.11.11-.23.2-.32.29s-.2-.12-.25-.21q-1.27-2-2.53-4.1c-1-1.64-2-3.29-3.05-4.94-.09-.14-.17-.3-.27-.44a1.55,1.55,0,0,0-.22-.24c-.31.28-.6.55-.88.83q-1.95,1.86-3.89,3.73c-.51.48-.51.48-.39,1.21l.3,1.84c0,.22.07.44.1.67a12.27,12.27,0,0,1-1.12,1.16,10.66,10.66,0,0,1-1.13,1.09,10.1,10.1,0,0,1-.6-1.57c-.19-.51-.37-1-.55-1.56s-.37-1-.56-1.59c-1.57-.57-3.15-1.1-4.76-1.69a.87.87,0,0,1,.13-.19c.62-.63,1.25-1.24,1.86-1.87a.6.6,0,0,1,.61-.19c.54.1,1.09.18,1.63.27l1,.16a.45.45,0,0,0,.51-.16,3.07,3.07,0,0,1,.26-.25l4.3-4.49C354,351.31,354,351.2,354.17,351.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.13,342.54h-12a1.06,1.06,0,0,0-1,.8l-1.5,6.29h17l-1.5-6.29A1.06,1.06,0,0,0,396.13,342.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.32 343.72 384.97 343.72 383.68 349.11 396.61 349.11 395.32 343.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5,356.44h4a0,0,0,0,1,0,0v5.1a.58.58,0,0,1-.58.58h-2.82a.58.58,0,0,1-.58-.58v-5.1A0,0,0,0,1,380.5,356.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.2,356.44h4a0,0,0,0,1,0,0v5.1a.58.58,0,0,1-.58.58h-2.82a.58.58,0,0,1-.58-.58v-5.1A0,0,0,0,1,396.2,356.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.35,
    y: 343.33,
    width: 3.82,
    height: 1.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.08,
    y: 348.49,
    width: 22.69,
    height: 9.64,
    rx: 1.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.46,352.75a2.56,2.56,0,1,1-2.56-2.55A2.56,2.56,0,0,1,386.46,352.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.69,352.75a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,399.69,352.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.63,
    y: 351.2,
    width: 5.67,
    height: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.63,
    y: 352.92,
    width: 5.67,
    height: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.58,
    y: 405.89,
    width: 16.23,
    height: 9.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.1,
    y: 405.89,
    width: 16.23,
    height: 9.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 378.62,
    x2: 407.11,
    y2: 378.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 385.76,
    x2: 407.11,
    y2: 385.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 392.9,
    x2: 407.11,
    y2: 392.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.25,
    y1: 400.05,
    x2: 407.11,
    y2: 400.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.33,
    y1: 62.87,
    x2: 268.82,
    y2: 62.87,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.31,
    y1: 62.87,
    x2: 181.8,
    y2: 62.87,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.22,
    y: 365.49,
    width: 12.54,
    height: 12.54,
    transform: "translate(-195.66 271.16) rotate(-45)",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.98,
    y: 365.49,
    width: 12.54,
    height: 12.54,
    transform: "translate(-189.58 285.84) rotate(-45)",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.73,
    y: 365.49,
    width: 12.54,
    height: 12.54,
    transform: "translate(-183.5 300.51) rotate(-45)",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.49,
    y: 347.88,
    width: 65.8,
    height: 7.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.23,
    y: 353.51,
    width: 52.32,
    height: 1.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.37,
    y: 244.46,
    width: 7.83,
    height: 172.34,
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.37,
    y: 295.22,
    width: 7.83,
    height: 40.94,
    style: {
      fill: "#ededed"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.14,170.1s1.08,6.25-.28,9.51-3.26,4.07-3.8,5.43.54,4.62.82,6,.81,2.72-1.36,3a28.86,28.86,0,0,1-3,.27s-5.16,6.52-8.69,6.52S131.32,195.37,127,188s-1.36-11.68,3.8-15.21S154.14,170.1,154.14,170.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.74,185.07c-.44,1.12-1.14,1.89-1.56,1.72s-.4-1.2,0-2.32,1.14-1.88,1.56-1.72S147.19,184,146.74,185.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,180.15s2.71-2.17,4.07,1.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,172l-.81,66.29s-5.17.27-11.69,0-15.75-3-26.35-9.78S95.18,200,95.18,200l16.3-19.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,151.36s-5.7,7.06-8.15,13.31.55,12.77.55,12.77l43.46-14.67s0-3.54-5.7-8.43-22.55-6.79-26.35-6.24S118,151.36,118,151.36Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.72,134.51s-11.68,3.54-13.85,9,3.8,10.86,7.87,12.22,16.3-3,18.21-7.06S134,140,130.5,136.42,122.08,134,120.72,134.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.73,171.19s-7.06,2.71-9,3.8-1.09,3.26-.27,4.89.54,3.26,1.9,3.26,27.16-8.42,36.13-10.59,9.78,0,10.32-2.72,1.09-8.42-.81-9.78S132.13,164.94,117.73,171.19Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,313.68l6.24,53.77s-8.42,13.31-10.59,23.09-13.31,32.87-13.31,32.87l10.05,5.43s18.47-27.44,24.45-36.95,9-13.58,9-17.11,7.61-55.12,7.61-55.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,428.55s3.83,1.64,2.92,4.2-11.49,6.57-11.86,7.11S74.27,428.55,74.27,428.55Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65,417.42c.55.55,21.72,10.4,21.72,10.4S66.79,441,65,443.88s2.73,9.49,4,11.86,8.76,6.57,10.22,7.3.36,1.64,0,4.19-1.1,3.1-2.92,3.1-13.69-1.27-17.52-3.46-4.74-6-6.38-7.48-2.19-1.46-2.19-1.46l-1.65,2.37s-2.18.18-5.83-2.19a13.2,13.2,0,0,1-4.93-5.84s3.83-6.93,6.39-8.76,4.74-5.65,5.47-8S53.65,417.42,53.65,417.42Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,439.17s4.51-5.27,6.47-3S68.34,439.17,68.34,439.17Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,439.17s9.64,2.56,7.38,3.31S68.34,439.17,68.34,439.17Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.49,446.55a13.78,13.78,0,0,1-.15-7.38,58.86,58.86,0,0,1,2.26,11.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.81,467.23c-4.56-.36-14.23-3.1-17.7-8.76-2.92-4.76-4.92-2.55-10-5.65a10.1,10.1,0,0,1-4.47-5.14c-1.56,2.3-2.83,4.59-2.83,4.59a13.2,13.2,0,0,0,4.93,5.84c3.65,2.37,5.83,2.19,5.83,2.19l1.65-2.37s.54,0,2.19,1.46,2.55,5.29,6.38,7.48,15.69,3.46,17.52,3.46,2.52-.53,2.89-3C77.42,467.41,75.09,467.41,72.81,467.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.32,316.67l26.62,56.48s-2.17,12.5.54,21.73,16,34.5,16,34.5l1.36,4.08,11.41-5.71s-7.06-22.54-8.69-31.51-.27-21.19-3-29.61-11.41-50.5-11.41-50.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.35,
    y1: 323.15,
    x2: 101.02,
    y2: 357.4,
    style: {
      fill: "none",
      stroke: "#858585",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,431.21s1.51-9.19,2.71-9.19,6,.9,4.07,3.92-6,10.69-6,10.69Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,423.14l-21.73,10.05,13.31,22a35.64,35.64,0,0,0,2.45,8.42c1.63,3.26,2.44,4.62,2.44,4.62l11.68-3.8s0-1.9,1.36-2.17a6.52,6.52,0,0,1,2.1.06,5.61,5.61,0,0,0,3.42-.51c4.35-2.16,15.42-7.67,17.37-8.76,2.45-1.36,2.65-4.92,1.83-6.28s-3.53-3-6.25-3-13,1.36-16.84.27-4.62-.54-6.25-2.44S144.08,423.14,144.08,423.14Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75,436.63s4.52-5.27,6.48-3S145.75,436.63,145.75,436.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75,436.63s9.64,2.56,7.38,3.32S145.75,436.63,145.75,436.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.9,444a13.91,13.91,0,0,1-.15-7.38,58.24,58.24,0,0,1,2.26,11.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,453.05c2.2-1.93,2.66-5.25,1.71-6.45h0a93.75,93.75,0,0,1-19,11.47c-13,5.89-18.12,5.89-20.73,6.21,1.4,2.76,1,3.81,2.11,4,9,1.12,11.68-3.8,11.68-3.8s0-1.9,1.36-2.17a6.09,6.09,0,0,1,2,0c1.31.2,4,.6,5.16,0C165.27,460.06,172,457,176.48,453.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91,223.62s12,64.8,16.3,77.84a108.94,108.94,0,0,1,5.16,22.78l-20.11,1.9Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,196.45s-9,9.24-15.75,27.71-11.14,68.06-12.77,77-2.45,21.8-.82,22.34,26.63,7.88,40.75,7.88,22.28.27,22.28-1.63-3-85.24-5.71-99.37-6.79-15.48-11.13-23.91S96.54,196.45,96.54,196.45Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36,213a67.33,67.33,0,0,0-9-14.12c-5.71-6.79-9.78-13.59-13.31-11.41s-7.07,6.79-6.25,9.78S108,207.86,111.48,210,118.55,216.28,119.36,213Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,218.54s-9.69-5.72-16.9-3a33.12,33.12,0,0,0-12.18,8.7l-2.49-9.95s9.94-7.7,17.15-7.7S118.23,210.83,120,218.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.84,233.44l-1.31-1L172,210.91a.82.82,0,0,1,1.21-.24h0a.81.81,0,0,1,.21,1.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.19,239.93a10.46,10.46,0,0,0,3.64-5.64c.7-3.46,1.47-8.57,2.8-9.69s7-3,7.9-3.38,2.71,0,1.64,2.58-4.81,3.43-4.81,3.43l4.53,2.31s2.73-5.27,3.53-5.1,1.11,1.33,1.64,4.21-.55,4-2.05,6-1.24,3.35-2.47,5.32S153,248,151.84,248.36,147.19,239.93,147.19,239.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,220.09s-4.35,6.52,0,17.93,13.86,41.56,17.12,41,36.13-25.27,36.67-27.71-6.52-11.14-7.33-12-6.8,4.07-10.87,5.7S126.43,250,126.43,250s-3.26-28-8.15-32.87-10.06-1.9-10.87-1.63",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.99 258.94 142.18 252.96 145.71 250.24 149.25 256.49 145.99 258.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,212.78c.29,1.08.27,20.33-.54,39.58S84.17,293,82.27,301.44s-6.78,9.48-15.18,8.94-20.34-2.71-25.76-7.05-4.88-13.82-1.9-21.69S47,248.84,47,238.27c0-7.72.81-15.85,3.42-23.15C54.8,202.94,64.68,203,76,203.36,82.49,203.57,87.79,206.15,89.59,212.78Z",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.89,210.81c-2.25-5.17-7.09-7.26-12.87-7.45-11.34-.37-21.22-.42-25.58,11.76-2.61,7.3-3.42,15.43-3.42,23.15,0,10.57-4.61,35.51-7.59,43.37-2.81,7.41-3.45,16.25,1,20.88-.94-4,.94-12.43,6.58-25.76,6.78-16,6.24-43.1,6.24-43.1s0-18.17,2.17-22.51,10.57-3.79,23.31-2.44A48.79,48.79,0,0,1,88.89,210.81Z",
    style: {
      fill: "#C33030",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,217.39l.42-.37a40.8,40.8,0,0,0-.15-4.24c-1.8-6.63-7.1-9.21-13.57-9.42-11.34-.37-21.22-.42-25.58,11.76-2.61,7.3-3.42,15.43-3.42,23.15a89.26,89.26,0,0,1-.78,10.21c1.72,1.15,4.25,2.35,5.12.09,1.36-3.53,3-26,3.8-32.54s9.21-6.23,19.25-4.88S89.32,217.39,89.32,217.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.73 277.85 63.83 247.75 79.01 249.11 77.12 279.2 65.73 277.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.97 274.6 56.24 256.97 70.88 259.41 68.98 278.93 55.97 274.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.62,273c-20.6,2.17-31.72-3.26-31.72-3.26s-6.23,17.09-8.13,23.59,1.9,7.86,10.57,10.85,21.69,5.69,24.13,1.08S83.62,273,83.62,273Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 461,
    y1: 470.33,
    x2: 468.33,
    y2: 470.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 470.33,
    x2: 451,
    y2: 470.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePage);
export default __webpack_public_path__ + "static/media/SinglePage.b76aa8e00320ba39768d61c93a65783d.svg";
export { ForwardRef as ReactComponent };